import React, { HTMLAttributes } from 'react';
import styles from './TopBarActions.module.css';

interface TopBarActionsProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const TopBarActions: React.FC<TopBarActionsProps> = ({ children, className = '', ...rest }) => {
  const classes = [styles.actions, className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default TopBarActions;